export const RATING_REQUEST = "RATING_REQUEST";
export const RATING_SUCCESS = "RATING_SUCCESS";
export const RATING_FAIL = "RATING_FAIL";
export const RATING_CLEAR_ERRORS = "RATING_CLEAR_ERRORS";